export const TENANT_FEATURES = {
  dashboard: 'dashboard',
  reports: 'reports',
  billing: 'billing',
  companies: 'companies',
  contacts: 'contacts',
  projects: 'projects',
  logs: 'logs',
  companyProjectInvoicing: 'companyProjectInvoicing',
  companySalesRep: 'companySalesRep',
  companyExpenseReport: 'companyExpenseReport',
} as const;

export const TENANT_ROUTES = {
  dashboard: 'dashboard',
  invoices: 'invoices',
  reports: 'reports',
  helpCenter: 'helpCenter',
  payment: 'payment',
  settings: 'settings',
  companies: 'companies',
  contacts: 'contacts',
  projects: 'projects',
  logs: 'logs',
  account: 'account',
  companyDetails: 'companyDetails',
} as const;

export const TENANT_MENU_ITEMS = {
  dashboard: 'dashboard',
  invoices: 'invoices',
  reports: 'reports',
  helpCenter: 'helpCenter',
  companies: 'companies',
  contacts: 'contacts',
  projects: 'projects',
  settings: 'settings',
  payment: 'payment',
  logs: 'logs',
  account: 'account',
} as const;

export const TENANT_TABS = {
  companyInvoices: 'companyInvoices',
  companyProjectInvoicing: 'companyProjectInvoicing',
  companySalesRep: 'companySalesRep',
  companyExpenseReport: 'companyExpenseReport',
} as const;

export const TENANT_PAGE_ENTRY_POINTS = {
  openInvoicesPaymentSettings: 'openInvoicesPaymentSettings',
} as const;

export type TenantFeatureKey =
  (typeof TENANT_FEATURES)[keyof typeof TENANT_FEATURES];

export type TenantRouteKey = (typeof TENANT_ROUTES)[keyof typeof TENANT_ROUTES];

export type TenantMenuItemKey =
  (typeof TENANT_MENU_ITEMS)[keyof typeof TENANT_MENU_ITEMS];

export type TenantTabKey = (typeof TENANT_TABS)[keyof typeof TENANT_TABS];

export type TenantPageEntryPointKey =
  (typeof TENANT_PAGE_ENTRY_POINTS)[keyof typeof TENANT_PAGE_ENTRY_POINTS];
